new Vue({
    el: '#loan-calculator',
    data: {
        intro: null,

        loanTypes: [],
        currencies: [],

        minAnnualInterestRate: null,
        maxAnnualInterestRate: null,

        minLoanAmount: null,
        maxLoanAmount: null,

        minLoanDurationInMonth: null,
        maxLoanDurationInMonth: null,

        minMonthly: null,
        maxMonthly: null,

        interestRate: null,
        effectiveInterestRate: null,
        monthlyInstallments: null,

        //selectedLoanType: null,
        //selectedLoanCurrency: null,
        selectedAnnualInterestRate: null,
        selectedLoanAmount: null,
        selectedLoanDurationInMonth: null,
        selectedMonthly: null,
        pickedField: 2,

        annualInterestId: "1",
        loanAmountId: "2",
        loanDurationInMonthId: "3",
        monthlyId: "4",

        schedule: [],
    },
    methods: {
        //createSchedule: function () {
        //    var _this = this;
        //    _this.schedule = [];
        //    for (var i = 1; i < _this.selectedLoanDurationInMonth + 1; i++) {
        //        _this.schedule.push({
        //            "month": i,

        //        });
        //    }
        //}
        calculate: function (activeFieldId) {
            var _this = this;
            var x = 0;
            var S = parseFloat(_this.selectedLoanAmount);
            var r = parseInt(_this.selectedAnnualInterestRate);
            var N = parseInt(_this.selectedLoanDurationInMonth);
            var P = parseInt(_this.selectedAnnualInterestRate) / 1200;

            if (_this.pickedField == _this.loanAmountId) {
                if (activeFieldId == _this.annualInterestId) {
                    //calculate monthly
                    _this.selectedMonthly = _this.calculateMonthly(P);
                }
                else if (activeFieldId == _this.loanAmountId) {
                    //calculate monthly
                    _this.selectedMonthly = _this.calculateMonthly(P);
                }
                else if (activeFieldId == _this.loanDurationInMonthId) {
                    //calculate monthly
                    _this.selectedMonthly = _this.calculateMonthly(P);
                }
                else if (activeFieldId == _this.monthlyId) {
                    //todo: calculate month
                    _this.selectedLoanDurationInMonth = _this.calculateLoanDuration(P);
                }
            } else if (_this.pickedField == _this.loanDurationInMonthId) {
                if (activeFieldId == _this.annualInterestId) {
                    //calculate monthly
                    _this.selectedMonthly = _this.calculateMonthly(P);
                }
                else if (activeFieldId == _this.loanAmountId) {
                    //calculate monthly
                    _this.selectedMonthly = _this.calculateMonthly(P);
                }
                else if (activeFieldId == _this.loanDurationInMonthId) {
                    //calculate monthly
                    _this.selectedMonthly = _this.calculateMonthly(P);
                }
                else if (activeFieldId == _this.monthlyId) {
                    //todo: calculate loan amount
                    _this.selectedLoanAmount = _this.calculateLoanAmount(P);
                }
            } else if (_this.pickedField == _this.monthlyId) {
                if (activeFieldId == _this.annualInterestId) {
                    //todo: calculate month
                    _this.selectedLoanDurationInMonth = _this.calculateLoanDuration(P);
                }
                else if (activeFieldId == _this.loanAmountId) {
                    //todo: calculate month
                    _this.selectedLoanDurationInMonth = _this.calculateLoanDuration(P);
                }
                else if (activeFieldId == _this.loanDurationInMonthId) {
                    //todo: calculate loan amount
                    _this.selectedLoanAmount = _this.calculateLoanAmount(P);
                }
                else if (activeFieldId == _this.monthlyId) {
                    //todo: calculate loan amount
                    _this.selectedLoanAmount = _this.calculateLoanAmount(P);
                }
            }
        },
        calculateMonthly: function (P) {
            var _this = this;
            x = parseFloat(_this.selectedLoanAmount) * (P + (P / (Math.pow((1 + P), parseInt(_this.selectedLoanDurationInMonth)) - 1)));
            x = Math.round(parseFloat(x) * 100) / 100;
            //_this.updateSlider(_this.monthlyId, x);
            if (!isFinite(x)) {
                return _this.selectedMonthly;
            }
            return x;
        },
        calculateLoanDuration: function (P) {
            var _this = this;
            if (_this.selectedMonthly < 1) {
                _this.selectedMonthly = 1;
            }
            x = parseFloat(_this.selectedMonthly);

            var t = x - parseFloat(_this.selectedLoanAmount) * P;

            if (t < 0) {
                t = 0;
            }
            N = Math.log10(x / t) / Math.log10(1 + P);
            N = Math.round(N);
            if (isNaN(N)) {
                N = 0;
            }
            if (!isFinite(N)) {
                return _this.selectedLoanDurationInMonth;
            }
            if (N <= 0) {
                N = 1;
            }
            return N;
        },
        calculateLoanAmount: function (P) {
            var _this = this;
            x = parseFloat(_this.selectedMonthly);
            S = x / (P + (P / (Math.pow((1 + P), parseInt(_this.selectedLoanDurationInMonth)) - 1)));
            S = Math.round(parseFloat(S) * 100) / 100;
            if (!isFinite(S)) {
                return _this.selectedLoanAmount;
            }
            return S;
        },
        //updateSlider: function (id, value) {
        //    if (!isNaN(value)) {
        //        //setTimeout(function () {
        //        var slider = document.getElementById(id);
        //        slider.noUiSlider.set(value);
        //        //}, 200);
        //    }
        //}
    },
    mounted: function () {
        var _this = this;
        if (!!window.loanCalculatorSettings) {
            _this.loanTypes = window.loanCalculatorSettings.loanTypes;
            _this.currencies = window.loanCalculatorSettings.currencies;

            _this.minAnnualInterestRate = window.loanCalculatorSettings.minAnnualInterestRate;
            _this.maxAnnualInterestRate = window.loanCalculatorSettings.maxAnnualInterestRate;

            _this.minLoanAmount = window.loanCalculatorSettings.minLoanAmount;
            _this.maxLoanAmount = window.loanCalculatorSettings.maxLoanAmount;

            _this.minLoanDurationInMonth = window.loanCalculatorSettings.minLoanDurationInMonth;
            _this.maxLoanDurationInMonth = window.loanCalculatorSettings.maxLoanDurationInMonth;

            _this.minMonthly = window.loanCalculatorSettings.minContribution;
            _this.maxMonthly = window.loanCalculatorSettings.maxContribution;

            _this.intro = window.loanCalculatorSettings.intro;

            _this.selectedAnnualInterestRate = window.loanCalculatorSettings.annualInterestRateDefaultValue;
            _this.selectedLoanAmount = window.loanCalculatorSettings.loanAmountDefaultValue;
            _this.selectedLoanDurationInMonth = window.loanCalculatorSettings.loanDurationInMonthDefaultValue;
            //_this.selectedMonthly = window.loanCalculatorSettings.contributionDefaultValue;

            //_this.selectedLoanCurrency = _this.currencies[0];

            //if (!!window.currentLoanId) {
            //    //_this.selectedLoanType = _this.loanTypes.find(e => e.id == window.currentLoanId);
            //    for (var i = 0; i < _this.loanTypes.length; i++) {
            //        console.log(i);
            //        if (_this.loanTypes[i].id == window.currentLoanId) {
            //            _this.selectedLoanType = _this.loanTypes[i];
            //            break;
            //        }
            //    }
            //}
            setTimeout(function () {
                _this.calculate(_this.loanAmountId);
            }, 200);
        }
    }
})